module.exports = __webpack_public_path__ + "static/images/jf-cxtj.e7b9083.png";